import gsap from 'gsap';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__BlockTimeline extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
        this._tabs = [];

        for (let i = 0, j = this.item.querySelectorAll('[data-tab]').length; i < j; i++) {
            this._tabs.push(new ScrollItem__BlockTimeline__Tab(this.item.querySelectorAll('[data-tab]')[i]));
        }

        Interaction.addListener('data-tab', (e) => {
            if (this._active) this._active.hide();
            this._active = this._tabs[e.target.dataset.index];
            this._active.show();
        }, "TimelineTabs");

        this._active = this._tabs[0];
        this._active.show();
    }

    dispose() {
        super.dispose();
        Interaction.removeListener("TimelineTabs");
        this._tabs.forEach(tab => tab.dispose());
        this._tabs = null;
    }
}

class ScrollItem__BlockTimeline__Tab {
    constructor(__linkTab) {
        this._linkTab = __linkTab;
        this._dom = GetBy.id(this._linkTab.dataset.tab);
    }

    show() {
        this._linkTab.setAttribute('aria-selected', 'true');
        gsap.to(this._dom, {
            opacity: 1,
            duration: .2,
            ease: 'power2.inOut',
            onStart: () => {
                this._dom.setAttribute('aria-selected', 'true');
            }
        });
    }

    hide() {
        this._linkTab.setAttribute('aria-selected', 'false');
        gsap.to(this._dom, {
            opacity: 0,
            duration: .1,
            ease: 'power2.inOut',
            onComplete: () => {
                this._dom.setAttribute('aria-selected', 'false');
            }
        });
    }  

    dispose() {
        this._linkTab = null;
        this._dom = null;
    }
}

Scroll._registerClass('BlockTimeline', ScrollItem__BlockTimeline);

export default ScrollItem__BlockTimeline;
